import { useCallback, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import useLayoutEffect from '@swf/core/hooks/useIsomorphicLayoutEffect';
import { select } from '@swf/core/store';

const useHandleNativeBack = () => {
  const history = useHistory();
  const prevLocationRef = useRef<string>(history.location.pathname);
  const isMobileEnabled = useSelector(select.device.isMobileEmbedded);

  const handlePopAction = useCallback(() => {
    const prevLocation = prevLocationRef.current;
    if (prevLocation && prevLocation !== '/homegames/clubs/') {
      history.push('/homegames/clubs/');
    } else {
      window.close();
    }
  }, [history]);

  useEffect(() => {
    prevLocationRef.current = history.location.pathname;
  }, [history.location.pathname]);

  useLayoutEffect(() => {
    if (isMobileEnabled) {
      return history.listen((historyLocation, action) => {
        if (action === 'POP') {
          handlePopAction();
        }
      });
    }
  }, [history, handlePopAction, isMobileEnabled]);
};

export default useHandleNativeBack;
